import type { FC } from "react"
import {
  Button,
  Flex,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Stack,
  Text,
} from "@chakra-ui/react"

import ProposalShareButton from "proposal/components/ctas/ProposalShareButton"
import { ROUTES } from "common/constants/routes"
import { EllipsisVertical } from "ui/components/icons/font-awesome/EllipsisVertical"
import type { Maybe } from "query/graphql"

type ProposalExpiredCTAProps = {
  slug: string
  proposalId?: Maybe<string>
}
const ProposalExpiredCTA: FC<ProposalExpiredCTAProps> = ({
  slug,
  proposalId,
}) => {
  return (
    <Stack
      align="center"
      color="gray.600"
      direction="row"
      justify={{ base: "center", lg: "right" }}
      spacing={4}
      width="100%"
    >
      <Stack
        align="center"
        direction="row"
        width={{ base: "100%", sm: "auto" }}
      >
        <Text textStyle="body.bold.lg">Proposal expired</Text>
      </Stack>

      <OptionsList proposalId={proposalId} slug={slug} />
    </Stack>
  )
}

type OptionsListProps = {
  slug: string
  proposalId?: Maybe<string>
}
const OptionsList: FC<OptionsListProps> = ({ slug, proposalId }) => {
  return (
    <Flex>
      <Menu>
        <MenuButton
          as={Button}
          bgColor="white"
          borderColor="gray.300"
          borderWidth="1px"
          px={3}
        >
          <Icon as={EllipsisVertical} fill="gray.600" />
        </MenuButton>
        <MenuList>
          {proposalId ? (
            <MenuItem>
              <ProposalShareButton
                url={ROUTES.governance.proposal.id(slug, proposalId, "")}
              />
            </MenuItem>
          ) : null}
        </MenuList>
      </Menu>
    </Flex>
  )
}

export default ProposalExpiredCTA
